<script setup lang="ts">
import {
  RelatieAanhefField,
  RelatieAdresField,
  RelatieEmailField,
  RelatieFinancieelEmailadresField,
  RelatieGeboortedatumField,
  RelatieParticulierNaamField,
  RelatieRekeningField,
  RelatieTelefoonField,
} from '@relatie-lib/relatieGegevens/relatiegegevensForm/fields';
import { isReadonlyInjectionKey } from '@relatie-lib/relatieGegevens/relatiegegevensForm/keys';
import FieldGroup from '@shared/form/FieldRowV2/FieldGroup.vue';
import { computed, provide } from 'vue';
import FormLayout from './FormLayout.vue';

const props = defineProps<{
  relatienummer?: number;
  isSubmitting: boolean;
  loading: boolean;
  kanOpslaan?: boolean;
  kanBewerken?: boolean;
  saveButtonText?: string;
}>();
const emit = defineEmits<{ save: [] }>();

const isInEditMode = defineModel<boolean>('modelValue');

const isReadonly = computed(() => !isInEditMode.value);

provide(isReadonlyInjectionKey, { value: isReadonly });
</script>

<template>
  <FormLayout
    :loading="props.loading"
    :kan-opslaan="props.kanOpslaan"
    :kan-bewerken="props.kanBewerken"
    :is-submitting
    @save="emit('save')"
    title="Particulier"
    v-model="isInEditMode"
    :save-button-text="props.saveButtonText"
  >
    <FieldGroup :class="{ '!gap-0': !isInEditMode }">
      <slot></slot>
      <RelatieAanhefField />
      <RelatieParticulierNaamField />
      <RelatieAdresField />
      <RelatieGeboortedatumField />
      <RelatieRekeningField id="relatiegegevens-relatie-iban" />
      <RelatieTelefoonField />
      <RelatieEmailField />
      <RelatieFinancieelEmailadresField />
    </FieldGroup>
  </FormLayout>
</template>
